export default function SocialMediaDashIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="#FFE9E1"
        d="M13.444 22.174c5.528 0 10.01-4.482 10.01-10.01 0-5.53-4.482-10.011-10.01-10.011-5.53 0-10.011 4.482-10.011 10.01 0 5.53 4.482 10.011 10.01 10.011z"
      />
      <path
        fill="#000"
        d="M17.48 16.098s-.567-.465-1.844.618c-1.276 1.084-1.447 3.004-.97 3.477.48.476 2.716-1.139 2.88-1.259.163-.12.77-.818.77-.818s-.112-.658-.178-.843c-.062-.19-.658-1.175-.658-1.175z"
      />
      <path
        fill="#FBA986"
        d="M15.152 14.844s-1.705-1.262-2.189-.888c-.483.375-1.225 3.03-1.054 3.604.098.33 1.069 1.015 2.49 1.89a70.847 70.847 0 002.448 1.412c1.09-.651 1.8-1.51 1.513-2.917l.222-.443-.36-.31-.026-.021c-.414-.357-1.123-1.084-1.345-1.455"
      />
      <path
        fill="#DAACDA"
        d="M20.887 18.23l-2.146-1.31-1.261-.822c.534 2.655-1.971 4.218-2.815 4.095.022.018.513.389 1.153.872 1.232.931 1.763 1.364 1.8 1.353 3.52-1.276 3.589-3.425 3.269-4.189z"
      />
      <path
        fill="#B078A7"
        d="M18.741 16.92l-1.261-.822c.567 2.567-1.939 4.284-2.815 4.095.022.018.513.389 1.153.872.822-.221 2.654-1.749 2.923-4.145z"
      />
      <path
        fill="#464F7A"
        d="M12.527 18.327a.763.763 0 001.026-.323l3.309-6.379a.624.624 0 00-.27-.843l-.24-.124a.624.624 0 00-.843.27L12.2 17.304a.762.762 0 00.327 1.022z"
      />
      <path
        fill="#509DFF"
        d="M6.749 12.21s.695.394 2.99-.134c1.366-.312 3.054-.814 5.665-.418.072-.04.145-.083.214-.127 1.222-.804 1.516-2.306.975-3.847-2.375-1.266-3.917-2.6-4.808-3.706a12.57 12.57 0 00-.992-1.105c-.895-.862-1.288-.837-1.288-.837S8.327 7.6 8.236 7.68c-.014.01.193.09.546.207-.64 1.506-2.033 4.324-2.033 4.324z"
      />
      <path
        fill="#FFCD3B"
        d="M15.403 11.655l1.782.72a.904.904 0 00.847-.102c.084-.058.164-.12.237-.182 1.003-.83 1.276-1.982.934-3.404a.892.892 0 00-.869-.68L16.59 7.68c.509 1.444.283 2.851-.75 3.684a2.027 2.027 0 01-.225.163c-.065.048-.138.088-.21.128z"
      />
      <path
        fill="#1C7DC6"
        d="M6.749 12.21s.695.394 2.99-.134c1.366-.312 3.054-.814 5.665-.418.072-.04.145-.083.214-.127.08-.051.156-.106.226-.164-.488-.098-1.157-.163-1.48-.233a5.672 5.672 0 00-3.084.19c-.444.156-1.015.341-1.327-.011-.324-.36-.048-.92.196-1.338.39-.67.68-1.393.866-2.142a8.631 8.631 0 00.021-4.088 8.478 8.478 0 00-.25-.872c-.895-.862-1.288-.837-1.288-.837S8.328 7.6 8.236 7.68c-.014.01.193.09.546.207-.64 1.506-2.033 4.324-2.033 4.324z"
      />
      <path
        fill="#F57F35"
        d="M15.403 11.655l1.782.72a.908.908 0 00.847-.102c.084-.058.164-.12.237-.182-.666-.19-1.437-.39-2.033-.622a2.595 2.595 0 00-.4-.105 2.093 2.093 0 01-.225.163c-.062.048-.135.088-.208.128z"
      />
      <path
        fill="#464F7A"
        d="M6.75 12.21c1.057.26 2.312-.963 3.134-2.897.083-.2.163-.404.236-.615a10.575 10.575 0 00.509-2.073c.018-.123.033-.247.048-.367.243-2.229-.302-4.036-1.411-4.309-1.335-.327-2.982 1.706-3.677 4.538-.694 2.833-.174 5.397 1.16 5.724z"
      />
      <path
        fill="#606C9C"
        d="M6.745 12.207c.15.037.306.044.462.022-1.109-.614-1.498-2.996-.858-5.604.614-2.516 1.982-4.4 3.214-4.56a1.137 1.137 0 00-.301-.12C7.927 1.618 6.28 3.651 5.585 6.484c-.694 2.832-.174 5.396 1.16 5.723z"
      />
      <path
        fill="#FFCD3B"
        d="M7.487 7.487c.098.688.651 1.36 1.498 1.648.277.094.586.152.899.174a11.164 11.164 0 00.745-2.687c.018-.124.033-.247.047-.367a3.379 3.379 0 00-.607-.28c-1.135-.39-2.222-.04-2.52.832a1.44 1.44 0 00-.062.68z"
      />
      <path
        fill="#F57F35"
        d="M7.487 7.487c.098.688.651 1.36 1.498 1.648.277.094.586.152.899.174a11.164 11.164 0 00.745-2.687c.018-.124.033-.247.047-.367a3.385 3.385 0 00-.476-.233c.018.127.066.258.076.367a1.96 1.96 0 01-.41 1.356c-.182.226-.47.419-.742.324-.095-.033-.2-.094-.28-.033-.055.044-.059.124-.044.193.015.07.04.138.025.204-.021.109-.145.174-.258.167-.112-.007-.21-.073-.298-.142a1.927 1.927 0 01-.564-.723c-.029-.07-.058-.142-.112-.193a.226.226 0 00-.106-.055z"
      />
      <path
        fill="#FBA986"
        d="M12.64 15.313c.836.32 2 .556 2.164.076.192-.567-.786-1.182-1.622-1.502-.31-.12-.804.098-.964.488-.16.389.113.818.422.938z"
      />
      <path
        fill="#EF9672"
        d="M14.193 15.724c-.47 0-1.091-.171-1.571-.353-.033-.01-.047-.047-.036-.08.01-.033.047-.047.08-.036.687.265 1.549.454 1.923.28.084-.04.135-.091.16-.164.171-.498-.702-1.087-1.585-1.426-.033-.01-.047-.047-.037-.08.011-.032.048-.047.08-.036.72.276 1.88.92 1.659 1.578a.414.414 0 01-.222.237 1.07 1.07 0 01-.451.08z"
      />
      <path
        fill="#FBA986"
        d="M12.295 16.233c.854.273 1.88.593 2.087.094.255-.61-.84-1.127-1.695-1.4-.316-.101-.807-.112-.978.393-.134.396.27.811.586.913z"
      />
      <path
        fill="#EF9672"
        d="M13.84 16.647c-.443 0-1.043-.192-1.563-.356a.06.06 0 01-.04-.076.06.06 0 01.076-.04c.77.243 1.825.581 2.014.127a.394.394 0 00-.01-.338c-.226-.484-1.226-.848-1.648-.982a.06.06 0 01-.04-.076.06.06 0 01.077-.04c.436.138 1.476.52 1.72 1.047a.523.523 0 01.01.436c-.087.218-.309.298-.596.298z"
      />
      <path
        fill="#FBA986"
        d="M12.069 17.134c.741.237 1.752.55 1.934.113.222-.53-.778-1.16-1.52-1.396-.276-.087-.716-.146-.92.49-.113.346.23.706.506.793z"
      />
      <path
        fill="#EF9672"
        d="M13.528 17.527c-.422 0-1.004-.185-1.473-.334a.06.06 0 01-.04-.077.06.06 0 01.076-.04c.633.2 1.695.538 1.858.15a.397.397 0 00-.018-.32c-.185-.404-.894-.815-1.465-.997a.06.06 0 01-.04-.076.06.06 0 01.076-.04c.611.192 1.335.622 1.538 1.062.07.145.077.287.022.418-.08.185-.28.254-.534.254z"
      />
      <path
        fill="#FBA986"
        d="M11.81 17.87c.644.254 1.66.48 1.83.097.222-.49-.775-.967-1.415-1.221-.24-.095-.621-.171-.829.385-.112.302.175.643.415.738z"
      />
      <path
        fill="#EF9672"
        d="M13.135 18.233c-.43 0-.997-.168-1.346-.31-.032-.01-.047-.047-.032-.08.01-.032.047-.047.08-.032.738.29 1.618.425 1.752.127a.282.282 0 000-.236c-.112-.273-.603-.597-1.385-.906-.033-.01-.047-.047-.033-.08.011-.032.047-.047.08-.032.837.33 1.327.658 1.455.97a.404.404 0 01-.004.331c-.084.182-.298.248-.567.248z"
      />
      <path
        fill="#FBA986"
        d="M17.069 16.04s-.197-1.542-.538-1.88c-.342-.335-2.168-1.884-2.404-1.49-.542.912 1.054 2.301 1.054 2.301s-.425 1.422.131 2.03"
      />
      <path
        fill="#EF9672"
        d="M15.313 17.062a.06.06 0 01-.044-.018c-.527-.579-.222-1.815-.156-2.051-.226-.204-1.564-1.47-1.037-2.353a.06.06 0 01.084-.022c.029.018.04.055.022.084-.51.858 1.025 2.21 1.04 2.225.018.015.025.04.018.062-.004.015-.408 1.393.116 1.971a.062.062 0 01-.004.087.076.076 0 01-.04.015z"
      />
      <path
        fill="#1C7DC6"
        d="M14.506 4.825l.153.466.92.265-.2 1.018.17.24 1.91-.77 4.632 1.403.891-4.222-.116-.614-1.327.393-6.579 1.952-.454-.13z"
      />
      <path
        fill="#509DFF"
        d="M15.419 1.582l-.913 3.243 1.12.31c-.11.603-.222 1.203-.236 1.243-.026.055 1.334-.483 2.007-.753l4.505 1.313.964-4.323-7.447-1.033z"
      />
      <path
        fill="#fff"
        d="M20.891 3.734c-.105 0-.214-.003-.32-.014-.422-.044-.778-.182-1.04-.404a.94.94 0 01-.065-.058.705.705 0 00-.262-.174c-.171-.044-.342.054-.506.152l-.025.015c-.378.218-.716.316-1.04.305-.385-.014-.724-.21-.884-.505a.785.785 0 01-.545-.044.796.796 0 01-.436-.574l.08-.015a.705.705 0 00.389.513c.149.069.32.083.476.043-.036-.083-.07-.225-.004-.345a.269.269 0 01.19-.127.186.186 0 01.167.058c.04.044.054.098.047.16a.38.38 0 01-.193.254c-.029.019-.062.033-.094.048.149.258.465.436.807.45.306.015.633-.083.993-.294l.025-.014c.171-.099.367-.215.567-.16.12.032.208.112.299.192l.061.055c.248.21.593.342.997.382.364.036.738-.004 1.098-.04l.007.08a6.32 6.32 0 01-.789.061zm-3.96-1.149h-.018a.169.169 0 00-.127.084c-.051.095-.018.21.01.28a.419.419 0 00.092-.044.313.313 0 00.152-.2.109.109 0 00-.025-.094.168.168 0 00-.084-.026zm3.546 2.219a.486.486 0 01-.24-.073c-.051-.03-.095-.07-.138-.102a.79.79 0 00-.204-.134c-.145-.059-.32-.037-.556.072-.033.015-.062.03-.095.044-.156.073-.316.149-.494.156-.215.007-.419-.087-.611-.182-.211-.101-.408-.196-.619-.163a.99.99 0 00-.261.087 1.63 1.63 0 01-.186.07.9.9 0 01-.803-.16.893.893 0 01-.324-.754l.08.008a.822.822 0 00.294.683.815.815 0 00.731.146c.059-.018.12-.044.179-.07.09-.036.181-.076.283-.09.236-.037.455.069.666.17.185.088.374.183.57.175.16-.007.313-.08.462-.149l.099-.043c.163-.073.403-.16.621-.073.088.036.157.09.226.149.043.036.083.069.13.098.11.07.262.091.339 0l.062.051a.288.288 0 01-.211.084z"
      />
      <path
        fill="#FFCD3B"
        d="M3.48 14.978c.618-1.21 3.091-1.673 4.717-.84 1.625.833 2.443 2.491 1.825 3.702-.618 1.21-3.09 1.673-4.716.84-1.626-.833-2.448-2.491-1.826-3.702z"
      />
      <path
        fill="#FFCD3B"
        d="M9.477 15.582c.025-.08.283-.818.465-1.331.07-.196-.109-.422-.294-.375l-1.328.575 1.157 1.13z"
      />
      <path
        fill="#fff"
        d="M8.444 17.855a.062.062 0 01-.058-.044 1.11 1.11 0 00-.502-.644 1.097 1.097 0 00-.807-.113c-.059.015-.12.037-.182.055-.178.058-.364.12-.55.062-.141-.044-.247-.15-.348-.251-.048-.047-.091-.091-.142-.131-.24-.193-.553-.23-.884-.273-.327-.04-.669-.08-.934-.287a.063.063 0 01-.011-.087.063.063 0 01.087-.011c.24.185.549.222.876.262.335.04.68.083.946.298.054.044.102.09.149.142.094.094.182.182.298.218.15.047.305-.007.473-.062a2.89 2.89 0 01.189-.058 1.21 1.21 0 01.898.127c.27.157.473.415.56.713a.062.062 0 01-.04.076.062.062 0 01-.018.008zm.466-1.022h-.008a.062.062 0 01-.054-.07c.018-.141-.099-.269-.222-.323-.146-.062-.32-.058-.466-.055-.17.004-.349.008-.516-.058-.21-.087-.356-.269-.495-.444-.141-.181-.276-.352-.476-.414-.17-.054-.364-.01-.549.03-.03.006-.055.01-.08.017-.2.04-.487.077-.695-.087a.066.066 0 01-.01-.087.067.067 0 01.087-.011c.127.102.316.12.593.065.025-.007.054-.01.08-.018.2-.043.407-.09.61-.025.237.072.39.265.535.454.135.171.262.331.444.408.141.058.305.054.465.05.156-.003.346-.007.516.066.16.069.32.24.295.447a.054.054 0 01-.055.055z"
      />
      <path
        fill="#FF4A60"
        d="M2.848 11.062l1.705-2.866a.543.543 0 00-.138-.709L2.873 6.331a.539.539 0 00-.815.204L.597 9.658a.536.536 0 00.181.673l1.295.898a.537.537 0 00.775-.167z"
      />
      <path
        fill="#FF4A60"
        d="M4.331 10.88l-.745-2.41-.96 1.7 1.705.71z"
      />
      <path
        fill="#fff"
        d="M1.862 9.546c.375.214 1.342-.219 1.342-.219S3.172 8.19 2.75 7.946a.582.582 0 00-.818.225.56.56 0 00-.044.396.48.48 0 00-.276.244c-.131.255-.015.582.25.735z"
      />
      <path
        fill="#86BB6B"
        d="M21.419 15.27a1.636 1.636 0 100-3.274 1.636 1.636 0 000 3.273z"
      />
      <path
        fill="#358F48"
        d="M21.419 15.349a1.713 1.713 0 01-1.466-.825 1.707 1.707 0 01-.152-1.466 1.718 1.718 0 111.618 2.29zm0-3.273a1.548 1.548 0 00-1.466 1.037 1.559 1.559 0 001.993 1.982c.44-.16.785-.506.938-.946a1.559 1.559 0 00-1.465-2.073z"
      />
      <path
        fill="#358F48"
        d="M22.258 12.956a1.715 1.715 0 01-1.465-.825l.138-.084a1.558 1.558 0 001.855.655l.054.152a1.66 1.66 0 01-.582.102zm-.839 2.394a1.713 1.713 0 01-1.466-.826l-.05-.084.094-.033a1.718 1.718 0 012.047.724l.051.083-.095.033a1.69 1.69 0 01-.581.102zm-1.273-.823a1.556 1.556 0 001.698.6 1.578 1.578 0 00-.756-.57 1.543 1.543 0 00-.942-.03z"
      />
      <path
        fill="#358F48"
        d="M21.03 15.284a.519.519 0 01-.182-.033c-.495-.175-.63-1.022-.31-1.931.15-.425.379-.793.64-1.04.277-.258.568-.356.811-.27.244.088.411.343.462.717.051.357-.003.79-.152 1.215-.15.425-.379.793-.64 1.04-.211.2-.43.302-.63.302zm.774-3.142c-.156 0-.338.087-.516.254-.244.23-.459.575-.6.978-.28.797-.182 1.586.21 1.724.186.066.415-.018.648-.233.244-.229.458-.574.6-.978.142-.4.193-.803.145-1.138-.043-.313-.17-.524-.356-.589a.517.517 0 00-.131-.018z"
      />
      <path
        fill="#358F48"
        d="M20.786 15.148l1.087-3.086.154.054-1.087 3.087-.154-.055z"
      />
      <path
        fill="#358F48"
        d="M19.835 13.164l.054-.155 3.087 1.087-.055.154-3.086-1.086z"
      />
    </svg>
  );
}
